import { FieldValues, FieldPath, Controller, UseControllerProps } from 'react-hook-form';
import { AppSliderField, AppSliderFieldType } from '../fields/slider/sliderField';

type HookFormSliderFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<AppSliderFieldType, 'value' | 'onChange'> & {
  name: TName;
  control: UseControllerProps<TFieldValues, TName>['control'];
  rules?: UseControllerProps<TFieldValues, TName>['rules'];
  onFocus?: () => void;
  defaultValue?: unknown;
};

export const HookFormSliderInputField = (props: HookFormSliderFieldProps) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={props.rules}
      defaultValue={props.defaultValue}
      render={({ field: { value, onChange, ref }, fieldState: { error }, formState: { isSubmitting } }) => (
        <div tabIndex={0} ref={ref}>
          <AppSliderField
            value={value}
            onChange={(val) => val !== undefined && onChange(val.toString())}
            {...props}
            errorProps={{
              ...props.errorProps,
              errors: error?.message ?? props.errorProps?.errors,
            }}
            disabled={props.disabled || isSubmitting}
          />
        </div>
      )}
    />
  );
};
